import { State } from '../reducers/rootReducer'
import { InfoModalData } from '../../entities/InfoModal'

const infoModalSelector = (state: State): InfoModalData => state.infoModal

export default infoModalSelector
